export const SAVED_PAIR_NOTE =
  "Saved closing figures — the pair SP shown is the figure saved at that closing. The SP additions on record don't add up to today's balance, so this pair trail isn't rebuilt week by week; the difference shows in the current week.";

const TEXT = { row: "Saved closing figures", carried: "Saved closing figures · carried", opening: "Opening = saved closing figures" };

/** Tag for pair figures taken straight from the saved closing (pair_source = "saved"). */
export function SavedFiguresTag({ kind = "row", testid }) {
  return (
    <span
      data-testid={testid}
      className="inline-flex mt-0.5 text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-sm bg-sky-100 text-sky-900 whitespace-nowrap"
    >
      {TEXT[kind]}
    </span>
  );
}
